<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{title}}</div>
      <div class="setting-addel mr-l15 mr-r5">
        <el-button size="mini" @click="addConfigOidList"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isDeleted" @click="deleteConfigOidList"><i class="fas fa-minus"></i></el-button>
      </div>
      <div>
        <el-button size="mini" :disabled="!(selectedTemplateGroupId.length == 1)" @click="onClickCopyOid">템플릿 복제</el-button>
      </div>
    </div>
    <div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="loading" ref="configOidTable" border :data="dataList" :span-method="objectSpanMethod" :columns="scriptColumns" row-class-name="c-dblclick"
  :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editConfigDictionary"  @selection-change="configChangeSelection"
  @condition-change="loadData" :pagination="false" remote>
    <template slot-scope="scope" slot="templateOidSlot">
      <div v-for="(item, index) in (scope.row.templateOid).split(',')" :key="index">
        {{item}}
      </div>
    </template>
  </el-table-wrapper>
  <w-config-oid-popup ref="configOidPopupRef" @reload-data="loadData" :select-vendor="selectVendor" :popup-type="popupType" :edit-row="editRow"
    :tmpl-target-type-list="tmplTargetTypeList"></w-config-oid-popup>
</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { isNil, forEach } from 'lodash';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WConfigOidPopup from '../popup/ConfigOidPopup';

export default {
  name: 'WConfigDictionaryView',
  components: {
    WConfigOidPopup,
  },
  props: {
    selectVendor: {
      type: Object,
      default: () => {},
    },
    tmplTargetTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '구성 OID 사전',
      loading: false,
      columnDefault,
      popupType: '',
      showSearchTool: false,
      isDeleted: false,
      selectedTemplateGroupId: [],
      editRow: {},
      dataList: [],
      scriptColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'dictCategory',
          label: '사전 종류',
          width: 150,
          remoteProp: 'target.dictCategory',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'dictInfo',
          label: '사전 정보',
          remoteProp: 'target.dictInfo',
          sortable: true,
          searchable: true,
          formatter: this.dicInfoFormatter,
        },
        {
          prop: 'targetConfigName',
          label: '구성 이름',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'templateOid',
          label: '구성 OID',
          remoteProp: 'nat.template_oid',
          searchable: true,
          scopedSlot: 'templateOidSlot',
        },
      ],
    };
  },
  watch: {
    selectedTemplateGroupId: {
      handler() {
        if (this.selectedTemplateGroupId.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
    selectVendor: {
      immediate: true,
      handler(val) {
        if (val) {
          this.title = `[${val.objCompanyName}] 구성 OID 사전`;
          this.$nextTick(() => {
            this.loadData();
          });
        } else {
          this.title = '구성 OID 사전';
        }
      },
    },
  },
  methods: {
    /**
     * 구성자원 동적로드를 하기 때문에 조회한 row 갯수만큼 index를 설정한다.
     * @author  Song
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (!isNil(row.rowCount)) {
          return { rowspan: row.rowCount, colspan: 1 };
        }
        return { rowspan: 1, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /**
     * [loadData > 구성 OID 리스트를 조회한다.]
     * @author  Song
     */
    loadData() {
      const menuCompanyId = this.selectVendor.objCompanyId;
      this.dataList = [];
      this.loading = true;
      const tableParams = this.$refs.configOidTable.getParameter();
      const params = {
        objCompanyId: menuCompanyId,
        ...tableParams,
      };
      NetdeviceSettingAPI.getConfigOidList(params).then((result) => {
        if (result.data.success) {
          this.dataList = result.data.data;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '구성 OID', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '구성 OID', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * [addConfigOidList 선택한 벤더의 OID 사전 항목을 추가한다.]
     * @author  Song
     */
    addConfigOidList() {
      this.editRow = {};
      this.popupType = 'ADD';
      this.$refs.configOidPopupRef.open();
    },
    /**
     * [deleteConfigOidList 선택한 벤더의 OID 사전 항목을 삭제한다.]
     * @author  Song
     */
    deleteConfigOidList() {
      const target = '구성 OID';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const params = {
          selectedTemplateGroupId: [],
        };
        forEach(this.selectedTemplateGroupId, (item) => {
          params.selectedTemplateGroupId.push(item.templateGroupId);
        });
        NetdeviceSettingAPI.deleteConfigTemplate(params).then((result) => {
          if (result.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    /**
     * [editConfigDictionary 필요한 parameter를 전달하며 수정 팝업을 뛰운다.]
     * @author  Song
     */
    editConfigDictionary(row) {
      const editConfigRow = cloneDeep(row);
      this.editRow = editConfigRow;
      this.popupType = 'EDIT';
      this.$refs.configOidPopupRef.open();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [configChangeSelection row 선택 이벤트]
     * @author  Song
     */
    configChangeSelection(selectVal) {
      // 반복 돌려서 선택한 데이터에서는 rowCount가 있는 녀석만 고르도록 하고, 상태를 관리하게 수정 (2020. 02. 11. Song)
      const selectValClone = cloneDeep(selectVal);
      this.selectedTemplateGroupId = selectValClone.filter((val) => val.rowCount);
    },
    /**
     * [dicInfoFormatter 장비 템플릿 - 선택된 장비 갯수 표시]
     * @author  Song
     */
    dicInfoFormatter(row, column, value) {
      let result = `${value}`;
      if (row.templateTargetType === 'TARGET_OBJ') {
        result += row.deviceCount === 1 ? '' : ` 외 ${row.deviceCount - 1}개 장비`;
      }
      return result;
    },
    /**
     * [onClickCopyOid 템플릿 복제 기능]
     * @author  Song
     */
    onClickCopyOid() {
      this.editRow = {};
      this.popupType = 'ADD';
      this.$refs.configOidPopupRef.open(this.selectedTemplateGroupId[0].templateGroupId);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/ConfigOidSettings/component/ConfigOidDictionaryView.vue